import React, { useCallback, forwardRef, useState, useEffect } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import moment from "moment";
import ja from "date-fns/locale/ja";
registerLocale("ja", ja);

const SearchFormCalendar = ({ eventDate, eventDateFunc }) => {
  // const DatePickerButton = forwardRef(({ value, onClick, isFirstEl }, ref) => (
  //   <button
  //     className={`btn btn-calendar ${isFirstEl ? 'ml-0' : 'ml-2 d-lg-none'}`}
  //     style={{background: '#6c757d', color: '#fff'}}
  //     onClick={onClick}
  //     ref={ref}
  //   >
  //     <div className="text-fz-small">カレン<br />ダー</div>
  //   </button>
  // ));
  const [startDay, setStartDay] = useState(0);

  const DatePickerButton = forwardRef(({ onClick }, ref) => (
    <button
      className={`btn btn-sm btn-secondary`}
      style={{ fontSize: "0.6rem" }}
      onClick={onClick}
      ref={ref}
    >
      別日を<br />選択
    </button>
  ));
  DatePickerButton.displayName = "Calendar";

  const DateOptionButton = useCallback(
    ({ index, isSelected = false, isFirstEl = false }) => {
      const momentObj = moment().add(index + startDay, "days");
      const btnColor = () => {
        if (momentObj.day() === 0) {
          return isSelected ? "text-danger bg-graydark" : "text-danger";
        } else if (momentObj.day() === 6) {
          return isSelected ? "text-primary bg-graydark" : "text-primary";
        } else {
          return isSelected ? "text-black bg-graydark" : "text-black";
        }
      };

      return (
        <button
          className={`btn-calendar ${btnColor()}`}
          onClick={() => eventDateFunc(momentObj.format("YYYY-MM-DD"))}
        >
          {index + startDay === 0 ? (
            <div className="btn-calendar__today">今日</div>
          ) : index + startDay === 1 ? (
            <div className="btn-calendar__tomorrow">明日</div>
          ) : (
            <div className="btn-calendar__week">
              {["日", "月", "火", "水", "木", "金", "土"][momentObj.day()]}
            </div>
          )}
          <div className="btn-calendar__date">{momentObj.format("M/D")}</div>
        </button>
      );
    },
    [eventDateFunc, startDay]
  );

  const [numOfDay, setNumOfDay] = useState(0);

    //親要素の幅を取得し、子要素がいくつ入るか算出
    useEffect(() => {
      const target = document.querySelector(".search-event__date").clientWidth;
      let count = Math.floor(target/56)//子要素の幅(52px)+左右マージン(2px+2px)
      setNumOfDay(count);
  }, );

  const handleCalendarOpen = () => {
    document.addEventListener('touchstart', (e) => {
        e.stopPropagation();
    }, true);
  };

  const DateOptionButtons = useCallback(
    () =>
      [...Array(30)].map((_, index) => (
        <DateOptionButton
          key={`dateoptionbutton_${index}`}
          index={index}
          isSelected={
            eventDate &&
            moment(eventDate).diff(moment().startOf("day"), "days") === index + startDay
          }
        />
      )),
    [eventDate, DateOptionButton]
  );

  return (
      <div className="search-event__day-choice">
        <div className="search-event__another-day">
          <DatePicker
            locale="ja"
            selected={eventDate && moment(eventDate).toDate()}
            minDate={new Date()}
            withPortal
            onChange={(date) => eventDateFunc(moment(date).format("YYYY-MM-DD"))}
            customInput={<DatePickerButton isFirstEl={true} />}
            onCalendarOpen={handleCalendarOpen}
          />
        </div>
        <div className="search-event__date-wrap">
          <div className="search-event__arrow is-left">
            {startDay > numOfDay - 1 ? (
              <button
                className="search-event__arrow-btn"
                onClick={() => setStartDay((prev) => prev - numOfDay)}
              >
                <svg
                  width="13"
                  height="20"
                  viewBox="0 0 13 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  >
                  <path
                    d="M12.12 2.12L4.24 10L12.12 17.88L10 20L-4.76837e-06 10L10 0L12.12 2.12Z"
                    fill="black"
                    fillOpacity="0.54"
                  />
                </svg>
              </button>
              ) : (
              <div className="search-event__arrow-btn">
                <svg
                  width="13"
                  height="20"
                  viewBox="0 0 13 20"
                  fillOpacity="0"
                  >
                </svg>
              </div>
              )}
          </div>
          <div className="search-event__date">
            <DateOptionButtons />
          </div>
          <div className="search-event__arrow is-right">
            <button
              className="search-event__arrow-btn"
              onClick={() => setStartDay((prev) => prev + numOfDay)}
            >
              <svg
                width="13"
                height="20"
                viewBox="0 0 13 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.880005 2.12L8.76 10L0.880005 17.88L3 20L13 10L3 0L0.880005 2.12Z"
                  fill="black"
                  fillOpacity="0.54"
                />
              </svg>
            </button>
          </div>
        </div>
        {/* <div className="mt-1">
          <DatePicker
            locale="ja"
            selected={eventDate && moment(eventDate).toDate()}
            minDate={new Date()}
            withPortal
            onChange={(date) => eventDateFunc(moment(date).format("YYYY-MM-DD"))}
            customInput={<DatePickerButton isFirstEl={true} />}
          />
        </div> */}
      </div>
  );
};

export default SearchFormCalendar;
